import React, { useContext }                        from 'react'
import { Navigate, Outlet, useLocation, useRoutes } from 'react-router-dom'
import { DashboardLayout, CustomerLayout }          from './ui/layouts/dashboard'
import { AppContext }                               from './App'
import SignInPage                                   from './user/SignInPage'
import CustomerSignInPage                           from './customer/CustomerSignInPage'
import CustomerTransactionsPage                     from './customer/CustomerTransactionsPage'
import MessagePage                                  from './message/MessagePage'
import MessagesPage                                 from './message/MessagesPage'
import OperatorsPage                                from './other/OperatorsPage'
import PartnersPage                                 from './partner/PartnersPage'
import UserPage                                     from './user/UserPage'
import UsersPage                                    from './user/UsersPage'
import ServicesPage                                 from './service/ServicesPage'
import NotFoundPage                                 from './other/NotFoundPage'
import TransactionPage                              from './transaction/TransactionPage'
import TransactionsPage                             from './transaction/TransactionsPage'
import PartnerPage                                  from './partner/PartnerPage'
import SharePage                                    from './service/SharePage'
import SharesStatisticsPage                         from './share/SharesStatisticsPage'
import ServicePage                                  from './service/ServicePage'
import ServiceOperatorPage                          from './service/ServiceOperatorPage'
import ServiceDigitalAccessPage                     from './service/ServiceDigitalAccessPage'
import ServiceInfoAnswerPage                        from './service/ServiceInfoAnswerPage'
import ServicePeriodPage                            from './service/ServicePeriodPage'
import DigitalAccessCodeGeneratePage                from './service/DigitalAccessCodeGeneratePage'
import MessageStatisticsPage                        from './message/MessageStatisticsPage'
import TransactionStatisticsPage                    from './transaction/TransactionStatisticsPage'
import CategoriesPage                               from './category/CategoriesPage'
import CategoryPage                                 from './category/CategoryPage'
import SmsBroadcastPage                             from './premium/SmsBroadcastPage'
import Consts                                       from './Consts'
import InvestmentTransactionSharePage               from './service/InvestmentTransactionSharePage'
import ServiceEmailPage                             from './service/ServiceEmailPage'
import ServiceMessageInputExportPage                from './service/ServiceMessageInputExportPage'
// layouts

// ----------------------------------------------------------------------

const ProtectedRoute = ({ allowedUserTypes, children }) => {

  const location = useLocation()
  const { user } = useContext(AppContext)
  if (user === null) {
    return <Navigate to="/sign-in" state={{ from: location }}/>
  }

  if (!!allowedUserTypes && allowedUserTypes.indexOf(user.type) === -1){
    return <Navigate to={'/messages'} />
  }

  return (<React.Fragment>{children}</React.Fragment>)
}

const AdminProtectedRoute = ({ requireFullAccess = false, children }) => {

  const { user } = useContext(AppContext)
  // allow only admin users, block readonly if requireFullAccess is true
  if (user?.type !== Consts.User.typeAdmin || (requireFullAccess && user?.readonly)) {
    return <Navigate to="/messages" />
  }

  return <>{children}</>
}

const CustomerProtectedRoute = ({ children }) => {

  const location = useLocation()
  const { phone } = useContext(AppContext)
  if (phone === null) {
    return <Navigate to="/customer/sign-in" state={{ from: location }}/>
  }

  return (<React.Fragment>{children}</React.Fragment>)
}

const OnlyPublicRoute = ({ children }) => {

  const location = useLocation()
  const { user, phone } = useContext(AppContext)
  if (user !== null || phone !== null) {
    return <Navigate to={'/'} state={{ from: location }}/>
  }

  return (<React.Fragment>{children}</React.Fragment>)
}
const IndexRoute = () => {

  const location = useLocation()
  const { user, phone } = useContext(AppContext)
  if (user !== null) {
    if (user.type === Consts.User.typePartner) {
      return <Navigate to={'/messages'} state={{ from: location }}/>
    } else if (user.type === Consts.User.typeAdmin) {
      return <Navigate to={'/services'} state={{ from: location }}/>
    }
    /** else {
     * nothing to do.. do not happens
    } */
  }
  if (phone !== null) {
    return <Navigate to={'/customer/transactions'} state={{ from: location }}/>
  }

  return <Navigate to={'/customer/sign-in'} state={{ from: location }}/>
}

export default function Router () {

  return useRoutes([
    {
      path: '/',
      element: <ProtectedRoute><DashboardLayout /></ProtectedRoute>,
      children: [
        { path: '/users', element: <AdminProtectedRoute requireFullAccess={true}><UsersPage /></AdminProtectedRoute> },
        { path: '/users/create', element: <AdminProtectedRoute requireFullAccess={true}><UserPage /></AdminProtectedRoute> },
        { path: '/users/:userId', element: <ProtectedRoute><UserPage /></ProtectedRoute> },
        { path: 'statistics/messages/', children: [
            { path: ':from/:to/:groupBy/:serviceIds', element: <ProtectedRoute><MessageStatisticsPage /></ProtectedRoute> },
            { path: ':from/:to/:groupBy', element: <ProtectedRoute><MessageStatisticsPage /></ProtectedRoute> },
            { path: ':from/:to', element: <ProtectedRoute><MessageStatisticsPage /></ProtectedRoute> },
            { path: '', element: <ProtectedRoute><MessageStatisticsPage /></ProtectedRoute> },
          ]
        },
        { path: 'statistics/transactions/', children: [
            { path: ':from/:to/:groupBy/:serviceIds', element: <ProtectedRoute><TransactionStatisticsPage /></ProtectedRoute> },
            { path: ':from/:to/:groupBy', element: <ProtectedRoute><TransactionStatisticsPage /></ProtectedRoute> },
            { path: ':from/:to', element: <ProtectedRoute><TransactionStatisticsPage /></ProtectedRoute> },
            { path: '', element: <ProtectedRoute><TransactionStatisticsPage /></ProtectedRoute> },
          ]
        },
        { path: 'statistics/shares/', children: [
            { path: ':from/:to/:groupBy/:serviceIds', element: <ProtectedRoute><SharesStatisticsPage /></ProtectedRoute> },
            { path: ':from/:to/:groupBy', element: <ProtectedRoute><SharesStatisticsPage /></ProtectedRoute> },
            { path: ':from/:to', element: <ProtectedRoute><SharesStatisticsPage /></ProtectedRoute> },
            { path: '', element: <ProtectedRoute><SharesStatisticsPage /></ProtectedRoute> },
          ]
        },
        { path: '/messages/:messageId', element: <ProtectedRoute><MessagePage /></ProtectedRoute> },
        { path: '/messages', element: <ProtectedRoute><MessagesPage /></ProtectedRoute> },
        { path: '/transactions/:transactionId', element: <ProtectedRoute><TransactionPage /></ProtectedRoute> },
        { path: '/transactions', element: <ProtectedRoute><TransactionsPage /></ProtectedRoute> },
        { path: '/services/', children: [
            { path: ':serviceId/share/create', element: <AdminProtectedRoute requireFullAccess={true}><SharePage /></AdminProtectedRoute> },
            { path: ':serviceId/share/:shareId', element: <AdminProtectedRoute><SharePage /></AdminProtectedRoute> },
            { path: ':serviceId/operator/create', element: <AdminProtectedRoute requireFullAccess={true}><ServiceOperatorPage /></AdminProtectedRoute> },
            { path: ':serviceId/operator/:serviceOperatorId', element: <AdminProtectedRoute><ServiceOperatorPage /></AdminProtectedRoute> },
            { path: ':serviceId/digital-access/generate', element: <ProtectedRoute><DigitalAccessCodeGeneratePage /></ProtectedRoute> },
            { path: ':serviceId/digital-access', element: <ProtectedRoute><ServiceDigitalAccessPage /></ProtectedRoute> },
            { path: ':serviceId/service-period/create', element: <AdminProtectedRoute requireFullAccess={true}><ServicePeriodPage /></AdminProtectedRoute> },
            { path: ':serviceId/service-period/:servicePeriodId', element: <AdminProtectedRoute><ServicePeriodPage /></AdminProtectedRoute> },
            { path: ':serviceId/message-input/export', element: <AdminProtectedRoute><ServiceMessageInputExportPage /></AdminProtectedRoute> },
            { path: ':serviceId/info-answer/create', element: <AdminProtectedRoute requireFullAccess={true}><ServiceInfoAnswerPage /></AdminProtectedRoute> },
            { path: ':serviceId/info-answer/:serviceInfoAnswerId', element: <AdminProtectedRoute><ServiceInfoAnswerPage /></AdminProtectedRoute> },
            { path: ':serviceId/investments/create', element: <AdminProtectedRoute requireFullAccess={true}><InvestmentTransactionSharePage /></AdminProtectedRoute> },
            { path: ':serviceId/investments/:transactionShareId', element: <AdminProtectedRoute requireFullAccess={true}><InvestmentTransactionSharePage /></AdminProtectedRoute> },
            { path: ':serviceId/email/create', element: <AdminProtectedRoute requireFullAccess={true}><ServiceEmailPage /></AdminProtectedRoute> },
            { path: ':serviceId/email/:serviceEmailId', element: <AdminProtectedRoute><ServiceEmailPage /></AdminProtectedRoute> },
            { path: 'create', element: <AdminProtectedRoute requireFullAccess={true}><ServicePage /></AdminProtectedRoute> },
            { path: ':serviceId', element: <ProtectedRoute><ServicePage /></ProtectedRoute> },
            { path: '', element: <AdminProtectedRoute><ServicesPage /></AdminProtectedRoute> },
          ]},
        { path: '/operators', element: <AdminProtectedRoute requireFullAccess={true}><OperatorsPage /></AdminProtectedRoute> },
        { path: '/partners/create', element: <AdminProtectedRoute requireFullAccess={true}><PartnerPage /></AdminProtectedRoute> },
        { path: '/partners/:partnerId', element: <AdminProtectedRoute><PartnerPage /></AdminProtectedRoute> },
        { path: '/partners', element: <AdminProtectedRoute><PartnersPage /></AdminProtectedRoute> },
        { path: '/categories/:categoryId', element: <ProtectedRoute><CategoryPage /></ProtectedRoute> },
        { path: '/categories', element: <ProtectedRoute><CategoriesPage /></ProtectedRoute> },
        { path: '/sms-broadcast/', children: [
            { path: ':from/:to/:serviceIds', element: <AdminProtectedRoute><SmsBroadcastPage /></AdminProtectedRoute> },
            { path: ':from/:to', element: <AdminProtectedRoute><SmsBroadcastPage /></AdminProtectedRoute> },
            { path: '', element: <AdminProtectedRoute><SmsBroadcastPage /></AdminProtectedRoute> },
          ]
        },
        { path: '*', element: <ProtectedRoute><NotFoundPage /></ProtectedRoute> },
      ],
    },
    {
      path: '/customer',
      element: <CustomerLayout />,
      children: [
        { path: '/customer/transactions', element: <CustomerProtectedRoute><CustomerTransactionsPage /></CustomerProtectedRoute> },
        { path: '/customer/sign-in', element: <OnlyPublicRoute><CustomerSignInPage /></OnlyPublicRoute> },
      ],
    },
    {
      path: '/',
      element: <Outlet />,
      children: [
        { path: '/sign-in', element: <OnlyPublicRoute><SignInPage /></OnlyPublicRoute> },
        { path: '/customer/sign-in', element: <OnlyPublicRoute><CustomerSignInPage /></OnlyPublicRoute> },
      ],
    },
    { index: true, element: <IndexRoute /> },
  ])
}
